import React, {Component} from 'react';
import { AutoSizer, Table, Column} from 'react-virtualized';

class ManagersTable extends Component {
	render() {
		return (
			<AutoSizer>
				{({ height, width }) => (
					<Table
						width={width}
						height={height}
						headerHeight={20}
						rowHeight={40}
						onRowClick={({event, index, rowData}) => this.props.onClick(event, index, rowData)}
						rowClassName="test"
						rowCount={this.props.data ? (this.props.data.managers ? this.props.data.managers.length : 0) : 0}
						rowGetter={({ index }) => this.props.data.managers[index]}
					>
						<Column
							cellDataGetter={({ rowData }) => {
								let name = 'N/A';

								if(rowData.accountID.firstname) {
									name = `${rowData.accountID.firstname} ${rowData.accountID.lastname}`;
								}

								return name;
							}}
							label='Name'
							width={200}
							className="test2"
						/>

					</Table>
				)}
			</AutoSizer>
		);
	}
}

export default ManagersTable;
